import { createFileRoute, redirect } from '@tanstack/react-router';
import { readStoredPage } from '../lib/ledger-state';

// `/` reopens the last ledger page (LOG by default).
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: readStoredPage() });
  },
});
